import { addToChainAfter, ApiHandlerDiscreteParameter, HasOnError, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { UpdateAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnSuccess & HasOnError<string>,
    UpdateAccountApiParameter,
    AccountModel,
    { account: AccountModel }
>;

export const ExecuteOnSuccessCallbackExtended: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult as any);
};

replaceInChain(chain, ExecuteOnSuccessCallback, ExecuteOnSuccessCallbackExtended);